import { Typography } from "@mui/material";
import CommonDialog from "./CommonDialog";

const DeleteConfirmationDialog = ({ name, open, onClose, onDelete }) => {
  return (
    <CommonDialog
      title={"Delete Confirmation"}
      open={open}
      onClose={onClose}
      onDelete={onDelete}
    >
      <Typography>Are you sure you want to delete {name}?</Typography>
    </CommonDialog>
  );
};

export default DeleteConfirmationDialog;
